/**
 * This class mirrors EvaluationData in @homeaway/abacus.
 *
 * @see {@link https://github.homeawaycorp.com/experimentation-platform/node-abacus/blob/master/API.md#EvaluationData|Evaluation Data docs}
 * @see {@link https://github.homeawaycorp.com/experimentation-platform/node-abacus/blob/master/lib/experiment/evaluation-data.js|Evaluation Data code}
 */
class EvaluationData {
    /**
     * Creates an EvaluationData object based on supplied context.
     *
     * @param {Object} context - experiment evaluation data
     */
    constructor(context) {
        if (context instanceof EvaluationData) {
            return context;
        }

        for (let attr in context) {
            if (context.hasOwnProperty(attr)) {
                this[attr] = context[attr];
            }
        }
    }
}

export default EvaluationData;
